export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B281E" />
    <path d="M32 8 L52 15 V31 C52 44 43 52 32 57 C21 52 12 44 12 31 V15 Z" fill="none" stroke="#E5A855" strokeWidth="3.5" strokeLinejoin="round" />
    <circle cx="32" cy="22" r="3.5" fill="none" stroke="#FAF8F5" strokeWidth="3" />
    <path d="M32 25.5 V46 M25 31 H39 M21 38 C22 44 27 47 32 47 C37 47 42 44 43 38" fill="none" stroke="#FAF8F5" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-serif-d text-2xl font-semibold tracking-tight ${light ? "text-[#FAF8F5]" : "text-[#0B281E]"}`}>Anchorwell</span>
      <span className="block font-mono-d text-[10px] uppercase tracking-[0.3em] text-[#E5A855] mt-1">Life &amp; Health</span>
    </span>
  </span>
);
